import React, { FC } from "react";
import { up } from "styled-breakpoints";
import { useBreakpoint } from "styled-breakpoints/react-styled";
import { GatsbyImage } from "gatsby-plugin-image";
import { HeaderProps } from "../Header";
import RichText from "../../RichText";
import Spacer from "../../Spacer";

import * as S from "./FullScreenHeader-styled";

const FullScreenHeader: FC<HeaderProps> = ({
  desktopImage,
  mobileImage,
  title,
  subtitle,
  paragraph,
  buttonLink,
  buttonContent,
  buttonColor,
  position,
  textColor,
}) => {
  const isTabletUp = useBreakpoint(up("tablet-portrait"));
  return isTabletUp ? (
    <S.HeaderContainer>
      <S.Container>
        <S.SubContainer>
          <S.ImageWrapper>
            <GatsbyImage image={desktopImage?.gatsbyImageData} alt='' loading='eager' />
          </S.ImageWrapper>
        </S.SubContainer>
        <S.MetaContainer>
          <S.MetaWrapper position={position}>
            <RichText
              document={title?.richText}
              textColor={textColor}
              alignment={"left"}
              textSize={[null, null, "f7", "f10"]}
              tracking='1px'
              lineHeight='1.05'
              textWrap='balance'
            />
            {subtitle && (
              <>
                <Spacer spacing='sm4' />
                <RichText
                  document={subtitle?.richText}
                  textSize={[null, null, "f2"]}
                  textColor={textColor}
                  fontFamily='helvetica'
                  lineHeight='1.3'
                  alignment={position === "right" || position === "left" ? "left" : "center"}
                  textWrap='balance'
                />
              </>
            )}
            {buttonLink && buttonContent && (
              <>
                <Spacer spacing='md2' />
                <S.Button
                  type={buttonLink?.link_type}
                  url={buttonLink?.url ?? ""}
                  color={buttonColor ?? "navy"}
                >
                  {buttonContent}
                </S.Button>
              </>
            )}
            {paragraph && (
              <>
                <Spacer spacing='md2' />
                <RichText
                  document={paragraph?.richText}
                  textSize={[null, null, "f2"]}
                  textColor={textColor}
                  fontFamily='helvetica'
                  alignment={position === "right" || position === "left" ? "left" : "center"}
                  maxWidth={
                    position === "right" || position === "left" ? "80%" : "min(60%, 31.25rem)"
                  }
                />
              </>
            )}
          </S.MetaWrapper>
        </S.MetaContainer>
      </S.Container>
    </S.HeaderContainer>
  ) : (
    <S.MobileContainer>
      <S.MobileImageContainer>
        <GatsbyImage
          image={mobileImage?.gatsbyImageData}
          alt=''
          loading='eager'
          imgStyle={{ borderBottomRightRadius: "32% 30%" }}
        />
        <S.TitleContainer>
          <RichText
            document={title.richText}
            textColor={textColor}
            textWrap='pretty'
            textSize={"f8"}
            maxWidth={"245px"}
          />
        </S.TitleContainer>
      </S.MobileImageContainer>
      <Spacer spacing='sm2' />

      {subtitle && (
        <>
          <Spacer spacing='sm1' />
          <RichText document={subtitle?.richText} textSize='f2' fontFamily='helvetica' />
        </>
      )}

      {buttonLink && buttonContent && (
        <>
          <Spacer spacing='md2' />
          <S.Button type={buttonLink?.link_type} url={buttonLink?.url ?? ""} color='navy'>
            {buttonContent}
          </S.Button>
        </>
      )}
      {paragraph && (
        <>
          <Spacer spacing='sm3' />
          <RichText document={paragraph?.richText} textSize='f2' fontFamily='helvetica' />
        </>
      )}
      <Spacer spacing='md2' />
    </S.MobileContainer>
  );
};

export default FullScreenHeader;
